import React from 'react';
import { 
    Typography, 
    Box, 
    Button, 
    Paper, 
    TextField, 
    IconButton, 
    Divider
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { useLeakCheckForm } from './LeakCheckFormContext';
import { CustomFieldsList } from './CustomFieldsList';

export const PressureTestsSection: React.FC = () => {
    const { form, addPressureTest, removePressureTest, updatePressureTestType } = useLeakCheckForm();
    
    if (!form) return null;
    
    return (
        <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h6">
                    Pressure Tests
                </Typography>
                <Button 
                    startIcon={<AddIcon />}
                    color="primary"
                    onClick={addPressureTest}
                    variant="contained"
                >
                    Add Test Type
                </Button>
            </Box>

            {form.pressureTests.length === 0 ? (
                <Paper variant="outlined">
                    <Box p={3} textAlign="center">
                        <Typography color="textSecondary">
                            No pressure tests configured. Click "Add Test Type" to add a pressure test section.
                        </Typography>
                    </Box>
                </Paper>
            ) : (
                form.pressureTests.map((test, idx) => (
                    <Box key={idx} mb={3}>
                        <Paper variant="outlined">
                            <Box p={2}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                    <TextField
                                        label="Test Type Name"
                                        value={test.testType}
                                        onChange={(e) => updatePressureTestType(idx, e.target.value)}
                                        variant="outlined"
                                        size="small"
                                        style={{ minWidth: 250 }}
                                    />
                                    <IconButton 
                                        color="secondary" 
                                        onClick={() => removePressureTest(idx)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>
                                
                                <Divider />
                                
                                <Box mt={2}>
                                    <CustomFieldsList
                                        title="Custom Fields"
                                        fields={test.customFields}
                                        sectionType="pressureTest"
                                        sectionIndex={idx}
                                    />
                                </Box>
                            </Box>
                        </Paper>
                    </Box>
                ))
            )}
        </>
    );
};